import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthUsuarioGuard } from './guards/auth-usuario.guard';
import { LayoutAppComponent } from './layout-app/layout-app.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutAppComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./modules/usuario/usuario.module').then(m => m.UsuarioModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'menus',
        loadChildren: () => import('./modules/menu/menu.module').then(m => m.MenuModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'sub-menus',
        loadChildren: () => import('./modules/sub-menu/sub-menu.module').then(m => m.SubMenuModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'camiones',
        loadChildren: () => import('./modules/camion/camion.module').then(m => m.CamionModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      // {
      //   path: 'destinos',
      //   loadChildren: () => import('./modules/destino/destino.module').then(m => m.DestinoModule),
      //   data: { extraParameter: 'sub-menu-1-1' },
      //   canActivate: [AuthUsuarioGuard]
      // },
      {
        path: 'reportes',
        loadChildren: () => import('./modules/reporte/reporte.module').then(m => m.ReporteModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      // {
      //   path: 'ciudades',
      //   loadChildren: () => import('./modules/ciudad/ciudad.module').then(m => m.CiudadModule),
      //   data: { extraParameter: 'sub-menu-1-1' },
      //   canActivate: [AuthUsuarioGuard]
      // },
      // {
      //   path: 'empresas',
      //   loadChildren: () => import('./modules/empresa/empresa.module').then(m => m.EmpresaModule),
      //   data: { extraParameter: 'sub-menu-1-1' },
      //   canActivate: [AuthUsuarioGuard]
      // },
      {
        path: 'documentos',
        loadChildren: () => import('./modules/documento/documento.module').then(m => m.DocumentoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      // {
      //   path: 'tipos-residuos',
      //   loadChildren: () => import('./modules/tipo-residuo/tipo-residuo.module').then(m => m.TipoResiduoModule),
      //   data: { extraParameter: 'sub-menu-1-1' },
      //   canActivate: [AuthUsuarioGuard]
      // },  
      {
        path: 'tipos-vehiculos',
        loadChildren: () => import('./modules/tipo-vehiculo/tipo-vehiculo.module').then(m => m.TipoVehiculoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },  
      {
        path: 'cargas-gasolina',
        loadChildren: () => import('./modules/carga-gasolina/carga-gasolina.module').then(m => m.CargaGasolinaModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'obras',
        loadChildren: () => import('./modules/obra/obra.module').then(m => m.ObraModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      // {
      //   path: 'precios-residuos',
      //   loadChildren: () => import('./modules/precio-residuo/precio-residuo.module').then(m => m.PrecioResiduoModule),
      //   data: { extraParameter: 'sub-menu-1-1' },
      //   canActivate: [AuthUsuarioGuard]
      // },
      {
        path: 'obra-solicitud-retiro-residuo',
        loadChildren: () => import('./modules/obra-solicitud-residuo/obra-solicitud-residuo.module').then(m => m.ObraSolicitudResiduoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'solicitud-retiro-residuo',
        loadChildren: () => import('./modules/solicitud-residuo/solicitud-residuo.module').then(m => m.SolicitudResiduoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'tareas',
        loadChildren: () => import('./modules/tarea/tarea.module').then(m => m.TareaModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'tareas-por-realizar',
        loadChildren: () => import('./modules/tarea-por-realizar/tarea-por-realizar.module').then(m => m.TareaPorRelizarModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'retiros',
        loadChildren: () => import('./modules/retiro/retiro.module').then(m => m.RetiroModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'obra-retiros',
        loadChildren: () => import('./modules/obra-retiro/obra-retiro.module').then(m => m.ObraRetiroModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'agenda',
        loadChildren: () => import('./modules/agenda/agenda.module').then(m => m.AgendaModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'choferes-tol',
        loadChildren: () => import('./modules/choferes-tol/choferes-tol.module').then(m => m.ChoferesTolModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'choferes-externo',
        loadChildren: () => import('./modules/choferes-externo/choferes-externo.module').then(m => m.ChoferesExternoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      {
        path: 'administradores-obra',
        loadChildren: () => import('./modules/administradores-obra/administradores-obra.module').then(m => m.AdministradoresObraModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },


      {
        path: 'regiones',
        loadChildren: () => import('./modules/region/region.module').then(m => m.RegionModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },

  
      {
        path: 'correos-electronicos',
        loadChildren: () => import('./modules/correo-electronico/correo-electronico.module').then(m => m.CorreoElectronicoModule),
        data: { extraParameter: 'sub-menu-1-1' },
        canActivate: [AuthUsuarioGuard]
      },
      
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
